import { StyleSheet } from '@react-pdf/renderer';

// Colores tomados del formato institucional F – CR - 03 (Word).
export const COLORS = {
    banner: '#77A84B',
    box: '#B4CEA2',
    boxSoft: '#E4EFDB',
    border: '#8FB273',
    title: '#375623',
    line: '#7F7F7F',
    red: '#C00000',
};

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 6,
        paddingTop: 12,
        paddingBottom: 10,
        paddingHorizontal: 18,
        color: '#000000',
    },

    // ---- Encabezado ----
    header: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginBottom: 2,
    },
    headerLeft: {
        width: 60,
        alignItems: 'center',
    },
    superLogo: {
        width: 24,
    },
    codeTag: {
        marginTop: 6,
        borderWidth: 0.5,
        borderColor: '#000000',
        paddingVertical: 1,
        paddingHorizontal: 4,
        fontSize: 4.5,
    },
    headerCenter: {
        flex: 1,
        alignItems: 'center',
    },
    osvielLogo: {
        width: 148,
    },
    tagline: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 6.5,
        color: COLORS.red,
        marginTop: 1,
    },
    headerRight: {
        width: 128,
        borderWidth: 0.7,
        borderColor: '#000000',
        borderRadius: 4,
        height: 46,
        justifyContent: 'flex-end',
        paddingHorizontal: 8,
        paddingBottom: 6,
    },

    // ---- Banner y numeración ----
    bannerRow: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 3,
    },
    bannerWrap: {
        flex: 1,
        alignItems: 'center',
    },
    banner: {
        backgroundColor: COLORS.banner,
        borderRadius: 3,
        paddingVertical: 3,
        width: 200,
        textAlign: 'center',
        fontFamily: 'Helvetica-Oblique',
        fontSize: 7,
    },
    numbersCol: {
        width: 168,
    },
    numberRow: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 1,
    },
    numberLabel: {
        width: 62,
        textAlign: 'right',
        paddingRight: 4,
        fontFamily: 'Helvetica-BoldOblique',
        fontSize: 7,
        color: COLORS.title,
    },
    numberValue: {
        flex: 1,
        backgroundColor: COLORS.boxSoft,
        borderWidth: 0.5,
        borderColor: COLORS.border,
        paddingVertical: 2,
        paddingHorizontal: 3,
        textAlign: 'center',
        fontFamily: 'Helvetica-Bold',
        fontSize: 7,
        minHeight: 11,
    },

    // ---- Cajas y títulos ----
    sectionTitle: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 6.5,
        marginTop: 4,
        marginBottom: 2,
    },
    box: {
        borderWidth: 0.7,
        borderColor: COLORS.line,
        borderRadius: 5,
        paddingVertical: 4,
        paddingHorizontal: 7,
    },
    greenBox: {
        borderWidth: 0.7,
        borderColor: COLORS.border,
        borderRadius: 5,
        backgroundColor: COLORS.box,
        paddingVertical: 4,
        paddingHorizontal: 7,
    },
    boxTitle: {
        fontFamily: 'Helvetica-BoldOblique',
        fontSize: 7,
        textAlign: 'center',
        marginBottom: 2,
    },

    // ---- Campos ----
    fieldRow: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        marginBottom: 2.5,
    },
    label: {
        fontFamily: 'Helvetica-Oblique',
        fontSize: 6.5,
        paddingRight: 2,
    },
    fill: {
        borderBottomWidth: 0.5,
        borderBottomColor: '#000000',
        borderBottomStyle: 'dotted',
        paddingLeft: 2,
        paddingBottom: 0.5,
    },
    value: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 6.5,
    },

    // ---- Autorizaciones ----
    authBox: {
        borderWidth: 0.7,
        borderColor: COLORS.line,
        borderRadius: 4,
        width: 62,
        height: 40,
        alignItems: 'center',
        paddingTop: 3,
    },
    authText: {
        fontFamily: 'Helvetica-Oblique',
        fontSize: 5,
        textAlign: 'center',
    },

    // ---- Tablas ----
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: COLORS.boxSoft,
        borderWidth: 0.5,
        borderColor: COLORS.border,
    },
    tableRow: {
        flexDirection: 'row',
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderColor: COLORS.border,
    },
    tableCell: {
        borderRightWidth: 0.5,
        borderColor: COLORS.border,
        paddingVertical: 2,
        paddingHorizontal: 2,
        fontSize: 5.5,
    },
    tableCellLast: {
        paddingVertical: 2,
        paddingHorizontal: 2,
        fontSize: 5.5,
    },

    // ---- Página 2 ----
    sectionHeader: {
        fontFamily: 'Helvetica-BoldOblique',
        fontSize: 7,
        color: COLORS.title,
        textAlign: 'center',
        borderTopWidth: 0.7,
        borderBottomWidth: 0.7,
        borderColor: COLORS.border,
        paddingVertical: 1.5,
        marginTop: 3,
    },
    legalBox: {
        backgroundColor: COLORS.boxSoft,
        paddingVertical: 3,
        paddingHorizontal: 6,
    },
    legalText: {
        fontFamily: 'Helvetica-Oblique',
        fontSize: 5.8,
        textAlign: 'justify',
        lineHeight: 1.25,
    },
    conditionsText: {
        fontSize: 4.4,
        textAlign: 'justify',
        lineHeight: 1.15,
    },
    signatureRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginTop: 18,
    },
    signatureLine: {
        width: 150,
        borderTopWidth: 0.7,
        borderColor: '#000000',
        paddingTop: 2,
        textAlign: 'center',
        fontSize: 5.5,
    },
    fingerprintBox: {
        width: 46,
        height: 56,
        borderWidth: 0.7,
        borderColor: '#000000',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingTop: 3,
        fontSize: 5,
    },
    footer: {
        marginTop: 10,
        textAlign: 'center',
        fontFamily: 'Helvetica-Bold',
        fontSize: 6,
        lineHeight: 1.3,
    },
});

export default styles;
